if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector("form");
        this.form.querySelector("[name=id]").disabled = false;
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.cart =
          document.querySelector("cart-notification") ||
          document.querySelector("cart-drawer");
        this.submitButton = this.querySelector('[type="submit"]');
        if (document.querySelector("cart-drawer"))
          this.submitButton.setAttribute("aria-haspopup", "dialog");
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute("aria-disabled") === "true") return;

        this.handleErrorMessage();

        this.submitButton.setAttribute("aria-disabled", true);
        this.submitButton.classList.add("loading");
        this.querySelector(".loading-overlay__spinner").classList.remove(
          "hidden"
        );

        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            "sections",
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append("sections_url", window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              this.handleErrorMessage(response.description);

              const soldOutMessage =
                this.submitButton.querySelector(".sold-out-message");
              if (!soldOutMessage) return;
              this.submitButton.setAttribute("aria-disabled", true);
              this.submitButton.querySelector("span").classList.add("hidden");
              soldOutMessage.classList.remove("hidden");
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {source: "product-form"});
            this.error = false;
            const quickAddModal = this.closest("quick-add-modal");
            if (quickAddModal) {
              document.body.addEventListener(
                "modalClosed",
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                {once: true}
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
            this.updateProgressBar(response.final_line_price);
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove("loading");
            if (this.cart && this.cart.classList.contains("is-empty"))
              this.cart.classList.remove("is-empty");
            if (!this.error) this.submitButton.removeAttribute("aria-disabled");
            this.querySelector(".loading-overlay__spinner").classList.add(
              "hidden"
            );
          });
      }

      updateProgressBar(total) {
        const previousTotal = window.cartStrings.total;
        const cartTotal = parseInt(total) / 100 + previousTotal;
        const freeShipMin = window.cartStrings.freeShippingMinimum;
        const diff = window.cartStrings.freeShippingMinimum - cartTotal;
        const diffPercent =
          (cartTotal / window.cartStrings.freeShippingMinimum) * 100;
        const freeGiftMin = window.cartStrings.giftCartMinimum;
        const root = document.documentElement;
        if (window.cartStrings.showCartGiftProgress) {
          const gwpAndShipDiff =
            freeGiftMin - window.cartStrings.freeShippingMinimum;
          let gwpDiffPercent;
          if (freeGiftMin > 1 && diff < 0) {
            gwpDiffPercent = (Math.abs(diff) / gwpAndShipDiff) * 100;
          } else if (freeGiftMin > 1 && diff >= 0) {
            gwpDiffPercent = 0;
          }
          if (
            (cartTotal >= freeShipMin && previousTotal < freeShipMin) ||
            (cartTotal < freeShipMin && previousTotal < freeShipMin)
          ) {
            setTimeout(() => {
              root.style.setProperty("--shipping-progress", `${diffPercent}%`);
              setTimeout(() => {
                root.style.setProperty("--gwp-progress", `${gwpDiffPercent}%`);
              }, 600);
            }, 1);
          } else {
            setTimeout(() => {
              root.style.setProperty("--gwp-progress", `${gwpDiffPercent}%`);
              setTimeout(() => {
                root.style.setProperty(
                  "--shipping-progress",
                  `${diffPercent}%`
                );
              }, 600);
            }, 1);
          }
          window.cartStrings.total = cartTotal;
          if (diff > 0) {
            document.querySelector(".cart__shipping-text .money").innerHTML =
              Shopify.formatMoney(diff * 100, "${{amount}}");
          }
        } else {
          setTimeout(() => {
            root.style.setProperty("--shipping-progress", `${diffPercent}%`);
          }, 1);
        }
      }

      handleErrorMessage(errorMessage = false) {
        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message"
          );

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
